<template>
<loader v-bind="{ loading }">
  <div>
    <columns>
      <column>
        <columns>
          <column>
            <router-link :to="{ name: 'environment-software', params: {
              environment: environment.id,
              app: environment.app_id
            }}">
              <div class="box is-fullheight has-text-centered hoverable">
                <p class="is-size-1">{{ overview.vulnerable_software.length }}</p>
                <p>Vulnerable Software</p>
              </div>
            </router-link>
          </column> 
          <column>
            <router-link :to="{ name: 'environment-routes', params: {
              environment: environment.id,
              app: environment.app_id
            }}">
              <div class="box is-fullheight has-text-centered hoverable">
                <p class="is-size-1">{{ overview.vulnerable_routes.length }}</p>
                <p>Vulnerable Routes</p>
              </div>
            </router-link>
          </column>
          <column>
            <router-link :to="{ name: 'environment-attributes', params: {
              environment: environment.id,
              app: environment.app_id
            }}">
              <div class="box is-fullheight has-text-centered hoverable">
                <p class="is-size-1">{{ overview.vulnerable_attributes.length }}</p>
                <p>Vulnerable Attributes</p>
              </div>
            </router-link>
          </column>
          <column v-if="overview.unclassified_middleware">
            <router-link :to="{ 
                name: 'environment-middleware', 
                params: {
                  environment: environment.id,
                  app: environment.app_id
                }
              }">
              <div class="box is-fullheight has-text-centered hoverable">
                <p class="is-size-1">{{ overview.unclassified_middleware }}</p>
                <p>Unclassified Middleware</p>
              </div>
            </router-link>
          </column>
        </columns>

        <columns>
          <column>
            <div class="box">
              <security-event-chart :events="overview.security_events"/>
            </div>
          </column>
        </columns>

        <columns>
          <column>
            <div class="box">
              <auth-event-chart :events="overview.security_events"/>
            </div>
          </column>
        </columns>
      </column>
    </columns>

  </div>  
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import EnvironmentNotSetup from '@/views/apps/Environment/partials/NotSetup'
import TlsCertificate from '@/views/apps/Environment/partials/Tls'
import Software from '@/views/apps/Environment/partials/overview/Software'
import EnvironmentAttributes from '@/views/apps/Environment/partials/EnvironmentAttributes'
import LaravelVersion from '@/components/LaravelVersion.vue'
import GitBranch from '@/components/GitBranch.vue'
import AuthEventChart from '@/views/apps/Environment/partials/AuthEventChart'
import SecurityEventChart from '@/views/apps/Environment/partials/SecurityEventChart'

export default {

  props: {
    environmentId: {
      type: Number|String
    }
  },

  components: {
    EnvironmentNotSetup,
    Software,
    TlsCertificate,
    EnvironmentAttributes,
    LaravelVersion,
    GitBranch,
    AuthEventChart,
    SecurityEventChart
  },

  data: () => ({
    loading: true
  }),

  created() {
    this.$store.dispatch('environment/loadOverview', this.environmentId).then(() => {
      this.loading = false
    })

    this.$bus.$on('load-environment-dashboard', (envId) => {
      this.$store.dispatch('environment/loadOverview', envId).then(() => {
        this.loading = false
      })
    })
  },

  computed: {
    ...mapGetters('environment', [
      'environment',
      'overview'
    ])
  }

}
</script>